<template>
    <div id="shelta-marketing-app" class="shelta-app">
        <Header />
      <transition name="fade" mode="out-in">
        <!-- Page 1: Squeeze Page -->
        <squeeze-page 
          v-if="currentPage === 1" 
          @submit="handleFormSubmit"
        />
        
        <!-- Page 2: Thank You Page -->
        <thank-you-page 
          v-else-if="currentPage === 2" 
          :user-data="submittedData"
          @back="currentPage = 1"
        />
      </transition>
    </div>
  </template>
  
  <script>
  import SqueezePage from '../../components/LeadMagnet/SqueezePage.vue';
  import ThankYouPage from '../../components/LeadMagnet/ThankYouPage.vue';
  import Header from '../../views/Header.vue';
  
  export default {
    name: 'LeadHome',
    components: {
      SqueezePage,
      ThankYouPage,
      Header
    },
    data() {
      return {
        currentPage: 1,
        submittedData: null
      };
    },
    methods: {
      handleFormSubmit(formData) {
        this.submittedData = formData;
        this.currentPage = 2;
      }
    }
  };
  </script>
  
  <style lang="scss">
  $font-sans: 'Inter', system-ui, -apple-system, sans-serif;
  $color-bg: #f8fafc;

  
  .shelta-app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.25s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  </style>
  